import { labelClass, helperClass, errorClass } from './classes'

const Field = ({ label, htmlFor, required, error, helper, children, className = '' }) => (
  <div className={className}>
    {label && (
      <label htmlFor={htmlFor} className={labelClass}>
        {label}
        {required && <span className="ml-0.5 text-red-500">*</span>}
      </label>
    )}
    {children}
    {error ? (
      <p className={errorClass}>{error}</p>
    ) : helper ? (
      <p className={helperClass}>{helper}</p>
    ) : null}
  </div>
)

export default Field
